<template>
  <img src='../assets/img/loading.gif' class='img' :class="imgclass" :src="showurl" @load="loadImageSucess" @error="loadImageFail"
    :mode="mode" />

</template>

<script>
  import {
    hexMD5
  } from '../util/md5.js'

  let servicer = "https://img.sx678.cn/"
  export default {
    props: {
      url: {
        type: String,
        default: ''
      },
      mode: {
        type: String,
        default: 'scaleToFill'
      },
      imgclass: {
        type: String,
        default: ''

      },
      sizeimg: {
        type: String,
        default: 'x640'
      }
    },
    computed: {
      // 计算属性的
      showurl: function() {
        return this.propertyToUrl(this.url)
      },
    },
    data() {
      return {
        error: false,
        loading: true
      };
    },

    methods: {
      propertyToUrl: function(value) {
        if (!value) {
          return;
        }
        let thumbSize = {
          original: "",
          x150: "_150X150",
          x300: "_300X300",
          x640: "_640X640"
        };

        let thumb = thumbSize[this.sizeimg];
        let values = value.split('.')
        var temp = values[0].split('_'),
          prefix = null,
          fileName = null;

        let fileType = values[1];
        if (fileType == "gif") {
          thumb = thumbSize.original;
        }

        if (temp.length == 1) {
          prefix = 'thisiscommonhh';
          fileName = temp[0];
        } else if (temp.length == 2) {
          prefix = temp[0];
          fileName = temp[1];
        }
        let digest = hexMD5(fileName);
        let sb = prefix + "/";
        let level = 3;
        for (let i = 0, length = digest.length; i < length && level != 0; i += 2) {
          if (level != 3) {
            sb += '/';
          }
          sb += (digest.substring(i, i + 2));
          --level;
        }
        sb += "/";
        sb += fileName;
        if (servicer.charAt(servicer.length - 1) != '/') {
          servicer += '/';
        }
        return servicer + sb + "/" + values[0] + thumb + '.' + values[1];
      },

      //加载成功;
      loadImageSucess: function(e) {
        this.loading = false;
        this.error = false
      },

      //加载失败;
      loadImageFail: function(e) {

        this.loading = false;
        this.error = true
      },

    },

  }
</script>

<style>
  
</style>



// WEBPACK FOOTER //
// src/components/loadImage.vue